<div data-cy="tournament-import-list" class="tournament-import-list-container">
  <!-- Export Button -->
  @if (paginationResult().totalItems > 0) {
    <div class="export-controls">
      <button
        type="button"
        class="btn btn-sm btn-info"
        (click)="onExportSourceTournaments()"
        title="Export source tournaments to CSV"
        >
        <i class="fa fa-file-excel-o"></i> Export to CSV
      </button>
    </div>
  }

  <!-- Source Tournament Table -->
  <div class="table-responsive">
    @if (paginationResult().totalItems > 0) {
      <table
        class="table table-striped table-hover"
        >
        <thead>
          <tr>
            <th class="col-number">
              <app-sortable-header
                column="tournamentId"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Number
              </app-sortable-header>
            </th>
            <th class="col-name">
              <app-sortable-header
                column="name"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Tournament Name
              </app-sortable-header>
            </th>
            <th class="col-location">
              <app-sortable-header
                column="location"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Location
              </app-sortable-header>
            </th>
            <th class="col-date">
              <app-sortable-header
                column="startDate"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Start Date
              </app-sortable-header>
            </th>
            <th class="col-date">
              <app-sortable-header
                column="endDate"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                End Date
              </app-sortable-header>
            </th>
            <th class="col-count">
              <app-sortable-header
                column="coursesCount"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Courses
              </app-sortable-header>
            </th>
            <th class="col-count">
              <app-sortable-header
                column="roundsCount"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Rounds
              </app-sortable-header>
            </th>
            <th class="col-count">
              <app-sortable-header
                column="playersCount"
                [sortConfig]="sortConfig()"
                (sort)="onSort($event)"
                >
                Players
              </app-sortable-header>
            </th>
            <th class="col-action">Import</th>
          </tr>
        </thead>
        <tbody>
          @for (t of paginationResult().items; track t) {
            <tr
              data-cy="source-tournament-row"
              >
              <td>{{ t.tournamentId }}</td>
              <td>{{ t.name }}</td>
              <td>{{ t.location }}</td>
              <td>{{ t.startDate | date : "MM/dd/yyyy" }}</td>
              <td>{{ t.endDate | date : "MM/dd/yyyy" }}</td>
              <td>{{ t.coursesCount }}</td>
              <td>{{ t.roundsCount }}</td>
              <td>{{ t.playersCount }}</td>
              <td>
                @if (!t.exists) {
                  <button
                    (click)="onOpenImportModal(t)"
                    class="btn btn-sm btn-primary action-button"
                    >
                    <i class="fa fa-download"></i> Import
                  </button>
                } @else {
                  <a
                    class="btn btn-sm btn-secondary action-button"
                    [routerLink]="'/tournaments/' + t.id"
                    >
                    <i class="fa fa-eye"></i> View
                  </a>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  <!-- Pagination Component - Outside of scrollable area -->
  @if (paginationResult().totalItems > 0) {
    <div class="pagination-wrapper">
      <app-table-pagination
        [paginationData]="paginationResult()"
        [itemDescriptor]="'Tournaments'"
        (pageChange)="onPageChange($event.page)"
        >
      </app-table-pagination>
    </div>
  }

  <!-- No Data Messages -->
  @if (
    paginationResult().totalItems === 0 && _sourceTournaments().length === 0
    ) {
    <div
      class="alert alert-info"
      >
      <i class="fa fa-info-circle"></i> No source tournaments found.
    </div>
  }

  @if (
    paginationResult().totalItems === 0 && _sourceTournaments().length > 0
    ) {
    <div
      class="alert alert-warning"
      data-cy="no-source-tournaments-message"
      >
      <i class="fa fa-exclamation-triangle"></i> No source tournaments match your
      search criteria.
    </div>
  }
</div>
